export default __webpack_public_path__ + "static/media/BetaLogo.fabf82a1.svg";